module.exports = __webpack_public_path__ + "static/media/rest.cd77c614.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/lsc/rest.svg
// module id = 439
// module chunks = 0